<template>
  <div class="loading z-index-20-bg">
    <div class="content">
      <img src="@/assets/cms-logo.svg" alt="" />
      <h1>Contact Manager System</h1>
      <p><img src="@/assets/spinner.svg" alt="" />Loading</p>
    </div>
    <img src="@/assets/logo.png" class="logo" />
  </div>
</template>

<script>
export default {
  name: 'Loading',
};
</script>

<style lang="scss" scoped>
.loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: $headerBackground;

  .logo {
    margin: 13px;
    margin-left: 20px;
    height: 43px;
  }

  .content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;

    img {
      width: 10.625rem;
      height: 10.625rem;
    }

    h1 {
      font-size: $fontSize40;
      margin: 2rem;
      color: white;
      text-align: center;
      font-weight: 400;
    }

    p {
      font-weight: 400;
      color: rgb(255, 255, 255, 0.38);
      font-size: $fontSize24;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 1.7rem;
        height: 1.7rem;
        margin-right: 1rem;
        filter: grayscale(100%);
      }
    }
  }
}
</style>
